import {
    actions,
    getProjectMeetingsDefaults,
    timeSlotOptions,
} from '../../../ComponentsV2/ProjectDashboard/Components/Virtual/meetings/meetingsSlice';

export const initialState = {
    timeSlotOptions,
    byProject: {},
};

const patchProject = (state, projectId, patch) => {
    if (!projectId) return state;
    return {
        ...state,
        byProject: {
            ...state.byProject,
            [projectId]: {
                ...getProjectMeetingsDefaults(),
                ...state.byProject[projectId],
                ...patch,
            },
        },
    };
};

const patchProjectIfId = (state, action, patch) => {
    const projectId = action.projectId || action.payload?.projectId;
    if (projectId) return patchProject(state, projectId, patch);
    return state;
};

function meetingsReducer(state = initialState, action) {
    switch (action.type) {
        case 'MEETINGS_SET_STATE': {
            const { projectId, patch } = action.payload || {};
            return patchProject(state, projectId, patch);
        }
        case 'MEETINGS_SET_SETTINGS_LOADING': {
            const { projectId, loading } = action.payload || {};
            return patchProject(state, projectId, { settingsLoading: loading });
        }
        case 'SET_TIME_SLOT_DURATION':
            return patchProjectIfId(state, action, {
                slotDuration: action.payload,
            });
        case 'SET_MEET_REMINDER_TIME':
            return patchProjectIfId(state, action, {
                meetReminderTime: action.payload,
            });
        case 'SET_MEET_COUNT':
            return patchProjectIfId(state, action, {
                meetingsAllowedCount: action.payload,
            });
        case 'SET_MEET_PARTICIPANT_COUNT':
            return patchProjectIfId(state, action, {
                noOfAllowedParticipantPerMeeting: action.payload,
            });
        case 'SET_DISABLE_EMAIL_NOTIFICATION':
            return patchProjectIfId(state, action, {
                disableEmailNotification: action.payload,
                enableConfirmationEmail: action.payload
                    ? false
                    : state.byProject[action.projectId]
                          ?.enableConfirmationEmail,
            });
        case 'SET_ENABLE_CONFIRMATION_EMAIL':
            return patchProjectIfId(state, action, {
                enableConfirmationEmail: action.payload,
            });
        case 'SET_CONFIRMATION_CUTOFF':
            return patchProjectIfId(state, action, {
                confirmationCutOffTime: action.payload?.confirmationCutOffTime,
                disableConfirmationCutOffTime:
                    action.payload?.disableConfirmationCutOffTime,
            });
        case 'SET_NETWORKING_PAGE_ID':
            return patchProjectIfId(state, action, {
                networkingPageId: action.payload,
            });
        case 'SET_DISABLE_DAILY_DIGEST':
            return patchProjectIfId(state, action, {
                disableDailyDigestEmail: action.payload,
            });
        case 'SET_DISABLE_SUMMARY_EMAIL':
            return patchProjectIfId(state, action, {
                disableSummaryEmail: action.payload,
            });
        case 'SET_DISABLE_PHYSICAL_MEETING':
            return patchProjectIfId(state, action, {
                disablePhysicalMeeting: action.payload,
            });
        case 'SET_DISABLE_ONLINE_MEETING':
            return patchProjectIfId(state, action, {
                disableOnlineMeeting: action.payload,
            });
        case 'SET_TIME_RANGES':
            return patchProjectIfId(state, action, {
                timeRanges: action.payload,
            });
        case 'SET_MEET_LOCATIONS':
            return patchProjectIfId(state, action, {
                locations: action.payload,
            });
        case 'SET_MEET_DEFAULT_DATA':
            return patchProjectIfId(state, action, {
                defaultData: action.payload,
            });
        case 'SET_BCC_EMAIL':
            return patchProjectIfId(state, action, {
                bccEmail: action.payload,
            });
        case 'RESET_MEETINGS_STORE':
            return { ...initialState };
        default:
            return state;
    }
}

export { actions as meetingsActions };
export default meetingsReducer;
